<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/home"><img :src="icBack" /></router-link>
        <span>Boletos</span>
        <router-link to="/home"><img :src="icClose" /></router-link>
      </div>
      <div class="content">
        <div class="errorMessage">
          <img :src="icAttention" />
          <h2>Erro ao consultar boleto!</h2>
          <p class="mensagem-erro">{{ mensagem }}</p>
          <p>Você será redirecionado para página principal em alguns segundos...</p>
        </div>
      </div>
      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import icBack from '@/assets/svg/ic-back.svg'
import icAttention from '@/assets/svg/ic-attention.svg'
import icClose from '@/assets/svg/ic-close.svg'
import FooterGlobal from '@/components/Footer.vue'
import { timerToReturnToHome } from '@/helper/timer'

export default defineComponent({
  name: 'ErroBoletoPage',
  components: {
    FooterGlobal,
  },
  data() {
    timerToReturnToHome(40000)

    return {
      icBack,
      icClose,
      icAttention,
      mensagem: 'Ocorreu um erro.',
    }
  },
  created() {
    this.mensagem = this.$route.query.mensagem || 'Ocorreu um erro.'
  },
})
</script>